import {
    Alert,
    Button,
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Icon,
    Input,
    Label,
    Row,
    TextArea,
    Spinner
} from "design-react-kit";
import SpinnerCustom from "../../layout/Spinner";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {properties} from "../../../config/properties";

const styles = {

    layoutRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2.5rem',
        marginBottom: '2.5rem',
    },
    colLeft: {
        flex: '1 1 45%',
        minWidth: '320px',
    },
    colRight: {
        flex: '1 1 45%',
        minWidth: '320px',
    },
    fullWidth: {
        width: '100%',
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle1: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe', // Fondamentale che abbia un colore di sfondo solido
        transition: 'transform 0.2s ease-in-out',

        // --- Aggiunte Chiave ---
        //position: 'sticky', // Attiva il contesto di sovrapposizione
        zIndex: 2,            // Mette il titolo su un livello superiore
    },

    card1: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
    firmaImage: {

        maxWidth: '100%',
        width: 'auto',
        maxHeight: '200px',
        objectFit: 'contain',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#f8f9fa',
        padding: '0.5rem',
        display: 'block',

    },
    firmaPlaceholder: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '120px',
        backgroundColor: '#f8f9fa',
        border: '1px dashed #ced4da',
        borderRadius: '6px',
        color: '#6c757d',
        fontStyle: 'italic',
        fontSize: '0.9rem',
    },
    tableRowText: {
        padding: '2rem',
        color: '#6c757d',
        fontSize: '1rem',
    },
};

const InviaMail = ({user}) => {

    const [messaggio, setMessaggio] = useState('Si trasmettono le firme autografe - per esteso ed abbreviate - dei funzionari autorizzati a sottoscrivere gli atti e i documenti rilasciati da questa Camera.');
    const [cc, setCc] = useState('');
    const [oggetto, setOggetto] = useState('Comunicazioni Specimen');
    const [includeSpecimen, setIncludeSpecimen] = useState(false);

    const [fileBase64, setFileBase64] = useState(null);
    const [fileName, setFileName] = useState(null);

    const [isSending, setIsSending] = useState(false);



    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        if (location.state?.esito) {
            window.scrollTo({top: 0, behavior: 'smooth'});
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
        }

    }, [location.state]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name); // Salva il nome del file
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Rimuove il prefisso
                setFileBase64(base64String);
            };
            reader.readAsDataURL(file);
        }
    };



    const sendMail = async () => {
        try {

            setAlert({visible: false, type: '', message: '' });
            setIsSending(true);

            const params = {
                oggetto,
                messaggio,
                cc,
                includeSpecimen,
                fileBase64,
                fileName,
                userID: user.userID,
                cciaa: user.cciaa,
                gruppoUtente:user.gruppoUtente,
                cciaas: user.cciaas
            };


            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/sendMail",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );


            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!res.ok) throw new Error("Errore HTTP");

            const data = await res.json();

            if(data.esito === 'OK'){
                window.scrollTo({top: 0, behavior: 'smooth'});
                setAlert({ visible: true, type: 'success', message: data.messaggio });

            }else{
                setAlert({ visible: true, type: 'danger', message: data.messaggio});
            }

        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: "Errore con il server"});
        }finally {
            setIsSending(false);
        }
    };

    return (

        <Container className={"py-lg-5"}>

            <h2>Invio Massivo</h2>

            {alert.visible && (
                <Alert color={alert.type} isOpen={alert.visible}
                       toggle={() => setAlert({...alert, visible: false})}>
                    {alert.message}
                </Alert>
            )}

            <Row>

                <Col lg={6} className="mb-4">
                    <Card  style={styles.card} className="h-100  shadow-bg border-0 p-3 card-hover" >
                        <CardBody className="d-flex flex-column" style={styles.cardBody} >
                            <h2 style={styles.sectionTitle}>
                                <Icon icon="it-user" size="sm" style={styles.titleIcon} />
                                Destinatari
                            </h2>
                            <div>

                                <Row>
                                    <Col sm={"auto"}>
                                        <p style={styles.fieldLabel}>A:</p>
                                    </Col>

                                    <Col sm={"auto"}>

                                        <Button outline size="sm" className={"mb-3"} onClick={() => {
                                            navigate('/private/elencoDestinatariMail')
                                        }}>
                                            Visualizza destinatari
                                        </Button>
                                    </Col>
                                </Row>

                                <p style={styles.fieldLabel}>CC:</p>
                                <Input
                                    id="cc"
                                    type="text"
                                    value={cc}
                                    onChange={(e) => setCc(e.target.value)}
                                    className={"mb-3"}
                                    style={styles.fieldValue}
                                />

                                <p style={styles.fieldLabel}>Oggetto:</p>
                                <Input
                                    id="oggetto"
                                    type="text"
                                    value={oggetto}
                                    onChange={(e) => setOggetto(e.target.value)}
                                    className={"mb-3"}
                                    style={styles.fieldValue}
                                />

                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col lg={6} className="mb-4">
                    <Card style={styles.card} className="h-100  shadow-bg border-0 p-3 card-hover">
                        <CardBody style={styles.cardBody} className="d-flex flex-column">
                            <h2 style={styles.sectionTitle}>
                                <Icon icon="it-files" size="sm" style={styles.titleIcon}/>
                                Allegati
                            </h2>
                            <div>

                                <Row>
                                    <Col sm={"auto"}>
                                        <p style={styles.fieldLabel}>Allega lista Specimen:</p>
                                    </Col>

                                    <Col sm={"auto"}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={includeSpecimen}
                                            onChange={(e) => setIncludeSpecimen(e.target.checked)}
                                        />


                                    </Col>
                                </Row>


                                <p style={styles.fieldLabel}>Allega altro documento:</p>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileUpload(e)}
                                    accept="*"
                                />


                            </div>
                        </CardBody>
                    </Card>
                </Col>

            </Row>

            <Row>
                <Col>
                    <Card style={styles.card} className="h-100  shadow-bg border-0 p-3 card-hover">
                        <CardBody style={styles.cardBody} className="d-flex flex-column">
                            <h2 style={styles.sectionTitle}>
                                <Icon icon="it-comment" size="sm" style={styles.titleIcon}/>
                                Messaggio
                            </h2>
                            <div>
                                <p style={styles.fieldLabel}>Compila corpo della mail</p>
                                <TextArea
                                    id="messaggio"
                                    value={messaggio}
                                    onChange={(e) => setMessaggio(e.target.value)}
                                    rows={10}
                                    required={true}
                                    style={{fontWeight: "bolder"}}
                                />
                            </div>

                            <div className="text-end mt-4">
                                <Button
                                    className="btn btn-outline-primary"
                                    type="button"
                                    onClick={sendMail}
                                    disabled={isSending}
                                >
                                    {isSending ? <Spinner active small /> : "Invia Mail"}
                                </Button>
                            </div>


                        </CardBody>

                    </Card>

                </Col>

            </Row>


        </Container>

    );


}
export default InviaMail;